import axios from "axios"
import { IKiz2DocumentGetDTO } from "../../coreapi-dto/dirs/kiz";
import { envF } from "../../../env";
import { IActDeductionGetDTO } from "../../coreapi-dto/documents/actDeduction";

export const getActDeductionItemUpdateDTO = async (idDocument: string, callback: (e) => void) => {

    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    const generateKizRequestUrl = (idDocumentItem) => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}/Item/${idDocumentItem}`
    }

    const generateInvoiceRequestUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/ActDeduction/${idDocument}`
    }

    let actDeduction = await axios.get<IActDeductionGetDTO>(
        generateInvoiceRequestUrl(),
        header
    )

    let items: any[] = []

    const itemsPush = async (x: any) => {
        if (!x.isKiz) {
            items.push({
                dateCreated: x.dateCreated,
                idGlobal: x.idGlobal,
                isKiz: x.isKiz,
                goodsCode: x.goodsCode,
                producer: x.producer,
                isKizBox: x.isKizBox,
                isOsu: x.isOsu,
                kizOsuDto: x.kizOsuDto,
                lot: x.lot,
                goods: x.goods,
                quantity: x.quantity,
                retailCostInfo: x.retailCostInfo,
                supplier: x.supplier,
                supplierCostInfo: x.supplierCostInfo,
                isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                gosContractFundingSourseName: x.gosContractFundingSourseName
            })
        } else {
            await axios.get<IKiz2DocumentGetDTO>(
                generateKizRequestUrl(x.idGlobal),
                header
            ).then((e) => {
                items.push({
                    dateCreated: x.dateCreated,
                    idGlobal: x.idGlobal,
                    isKiz: x.isKiz,
                    isKizBox: x.isKizBox,
                    isOsu: x.isOsu,
                    kizOsuDto: x.kizOsuDto,
                    lot: x.lot,
                    goods: x.goods,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    quantity: x.quantity,
                    retailCostInfo: x.retailCostInfo,
                    supplier: x.supplier,
                    supplierCostInfo: x.supplierCostInfo,
                    kizs: e.data.items[0].kizes,
                    kizBoxes: e.data.items[0].kizBoxes,
                    kizOsuDtos: e.data.items[0].kizOsuDtos,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    gosContractFundingSourseName: x.gosContractFundingSourseName
                })
            }).catch(() => {
                items.push({
                    dateCreated: x.dateCreated,
                    idGlobal: x.idGlobal,
                    isKiz: x.isKiz,
                    isKizBox: x.isKizBox,
                    isOsu: x.isOsu,
                    kizOsuDto: x.kizOsuDto,
                    lot: x.lot,
                    goods: x.goods,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    quantity: x.quantity,
                    retailCostInfo: x.retailCostInfo,
                    supplier: x.supplier,
                    supplierCostInfo: x.supplierCostInfo,
                    kizs: [],
                    kizBoxes: [],
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    gosContractFundingSourseName: x.gosContractFundingSourseName
                })
            })
        }
    }

    const addItems = async () => {
        const unresolvedPromises = actDeduction.data.items.map((x) => itemsPush(x));
        await Promise.all(unresolvedPromises);
    }

    addItems().then(() => callback(items));
}